import { HttpClient } from "@angular/common/http";
import { UrlServidor } from "../util/url-servidor";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DanfeCfop } from "../api/dto/danfe/danfe-cfop";

@Injectable({
    providedIn: 'root',
})
export class DanfeCfopService {
    constructor(private http: HttpClient) { }
    private url : string = UrlServidor.URL_BASE + 'danfe-cfop';

    listar(): Observable<DanfeCfop[]>{
        return this.http.get<DanfeCfop[]>(this.url);
    }

    listarPorCstCsosn(cstCsosn?: string): Observable<DanfeCfop[]>{
        return this.http.get<DanfeCfop[]>(`${this.url}/cst-csosn/${cstCsosn}`);
    }

    
}